const SEARCH_PANEL_HEIGHT = 336;

export const styles = {
  searchWithPreview: {
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    borderTop: 1,
    borderColor: 'divider',
    height: SEARCH_PANEL_HEIGHT
  },
  searchEmpty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    height: SEARCH_PANEL_HEIGHT
  }
};
